import type { UUID } from "@/Shared/types";
import type { SavedBroker } from "@freightsimple/generated-dashboard-openapi-client/models/SavedBroker";
import { Button } from "@freightsimple/ui-core/Controls/Button";
import { Dropdown } from "@freightsimple/ui-core/Controls/Dropdown";
import { Row } from "@freightsimple/ui-core/ComponentLayout/Row";

interface SavedBrokersDropdownProps {
  savedBrokerId: UUID | undefined;
  onSetSavedBrokerId: (brokerId: UUID) => void;
  savedBrokers: Array<SavedBroker>;
  width?: number | undefined;
  onAddBroker?: (() => void) | undefined;
}

const BrokersSavedDropdown: React.FC<SavedBrokersDropdownProps> = (
  props: SavedBrokersDropdownProps,
) => {
  const options = props.savedBrokers.map((sb) => {
    const address = sb.broker.address;
    if (!address) {
      throw new Error("Missing broker.address");
    }
    return {
      value: sb.savedBrokerId,
      label: sb.broker.businessName ?? sb.savedBrokerId,
      description: `${address.city}, ${address.stateOrProvinceCode}`,
    };
  });

  function onChange(value: string) {
    const broker = props.savedBrokers.find((l) => l.savedBrokerId === value);
    if (broker === undefined) {
      throw new Error("Missing broker");
    }
    props.onSetSavedBrokerId(value);
  }

  return (
    <Row gap={4}>
      <Dropdown
        data-testid="saved-brokers-dropdown"
        value={props.savedBrokerId}
        onChange={onChange}
        options={options}
        placeholder="Select an customs broker"
        width="xl"
      />

      {props.onAddBroker && (
        <Button size="link" onClick={props.onAddBroker}>
          or add new customs broker
        </Button>
      )}
    </Row>
  );
};
export default BrokersSavedDropdown;
